import { Box } from '@chakra-ui/react'
import Select from 'components/form/react-select'
import React, { useCallback } from 'react'
import { SelectOption } from 'types/transaction.type'


type LogFilterType = {
  options: SelectOption[]
  setActive: Function
  active: SelectOption
}

export const LogFilter: React.FC<LogFilterType> = ({ options, setActive, active }) => {
  const handleChange = useCallback(e => {
    setActive(e)
  }, [])

  return (
    <Box>
      <Select onChange={handleChange} value={active} options={options} />
       
    </Box>
  )
}
